import React from "react";
import clsx from "clsx";
import Layout from "Layout";
import {
  Grid,
  TextField,
  Paper,
  makeStyles,
  Typography,
  FormControlLabel,
  Checkbox,
  Button,
} from "@material-ui/core";
import useApi from "Hooks/useApi";
import Chart from "./barChart";
import Alert from "@material-ui/lab/Alert";
import MuiAlert from "@material-ui/lab/Alert";
import useAuth from "Hooks/useAuth";
import googleAnalytics from "fuction/googleAnalytics";
import { message } from "constants/message";
import NoYesDialog from "Components/CommonDialog2Choices";

import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  subtitle: {
    marginLeft: "5px",
    marginBottom: "5px",
  },
  checkbox: {
    marginRight: 0,
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  /* Add 2023.05.31 */
  countDef: {
    color: "#000"
  },
  countErr: {
    color: "#f00"
  }
}));

export default function FilterHorse(props) {
  const { request, convertQueryParam } = useApi();
  const { state } = useAuth();
  const messages = message();
  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  const [filterHorse, setFilterHorse] = React.useState([]);
  const [currentLimit, setCurrentLimit] = React.useState(0);
  const [maxWords, setMaxWords] = React.useState(0);
  const [keywords, setKeywords] = React.useState("");
  const [keywordsCount, setKeywordsCount] = React.useState(0);
  const [excludeKeywords, setExcludeKeywords] = React.useState("");
  const [excludeKeywordsCount, setExcludeKeywordsCount] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [locked, setLocked] = React.useState(false);
  const [lock, setLock] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [isSuccess, setIsSuccess] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  //  Update 2023.05.31
  const [isErrorKeywords, setIsErrorKeywords] = React.useState(false);
  const [isErrorExcludeKeywords, setIsErrorExcludeKeywords] = React.useState(false);
  const [errorMessageKeywords, setErrorMessageKeywords] = React.useState("");
  const [errorMessageExcludeKeywords, setErrorMessageExcludeKeywords] = React.useState("");

  const dateFrom = dayjs().subtract(2, "month").startOf('month').format("YYYY-MM-DD 00:00:00");
  const dateTo = dayjs().endOf('month').format("YYYY-MM-DD 23:59:59");

  const [dialogConfig, setDialogConfig] = React.useState(undefined);

  // TODO: スタータープラン廃止後は除外キーワード表示関連部分を削除する
  const starterPlan = ["devel", "silver", "gold", "platinum", "diamond"];
  const [contractType, setContractType] = React.useState("");

  // 月間取得可能投稿件数の増量オブション件数表示対応
  const [limitExceed, setLimitExceed] = React.useState({
    enable: true,
    remain: 0,
  });

  const hasSpaces = () => {
    return (keywords.includes(' ') || keywords.includes('　'));
  };

  const submit = async () => {
    // 取得キーワードにスペースが含まれていた場合にダイアログを表示、スペースが意図したものでなかったら処理を抜ける
    const ret = (!hasSpaces()) ? 'ok' : await new Promise((resolve) => {
      setDialogConfig({
        onClose: resolve,
        title: '取得キーワードに空白が入っておりますが、お間違いないでしょうか？',
        message: 'AND条件は、”,“（カンマ）区切りで横に並べて登録をお願いします'
      });
    });
    setDialogConfig(undefined);
    if (ret !== 'ok') return;

    let data = {
      track: keywords.split("\n"),
      no_track: excludeKeywords.split("\n"),
    };

    if (state.user.master) {
      data["lock"] = lock;
    };

    request({
      method: "PUT",
      url: `config/:account_id/keywords`,
      data: data,
    })
      .then((data) => {
        setLocked(data.meta.locked);
        setIsError(false);
        setIsSuccess(true);
      })
      .catch((error) => {
        setIsError(true);
        setIsSuccess(false);
        switch (error.response.status) {
          case 400:
            setErrorMessage(messages.errorMsg.overKeyword);
            break;
          case 403:
            setErrorMessage(messages.errorMsg.lokedKeyword);
            break;
        }
      });
  };

  const fetchData = () => {
    // アカウントIDを取得していなければ返す
    if (!state.user.account_id) {
      return;
    }

    // フィルタホース情報取得
    request({
      method: "GET",
      url: `data/:account_id/tweets?${convertQueryParam({
        unit: "date",
        range: [dateFrom,dateTo],
      })}`,
    }).then((data) => {
      setFilterHorse(data.data);
    });

    // フィルタホース上限取得
    request({
      method: "POST",
      url: `config/:account_id/account`,
      data: {
        "attrs": [
          "max_words",
          "max_current",
          // TODO: スタータープラン廃止後は除外キーワード表示関連部分を削除する
          "contract_type",
          "exceed",
        ]
      },
    }).then((filterhorse) => {
      setMaxWords(filterhorse.data.max_words);
      setCurrentLimit(filterhorse.data.max_current);
      // TODO: スタータープラン廃止後は除外キーワード表示関連部分を削除する
      setContractType(filterhorse.data.contract_type);
      setLimitExceed(filterhorse.data.exceed);
    });

    // キーワード設定取得
    request({
      method: "GET",
      url: `config/:account_id/keywords`,
    }).then((data) => {
      setLocked(data.meta.locked);
      setLock(data.meta.locked);
      setKeywords(data.data.track.join("\n"));
      setExcludeKeywords(data.data.no_track.join("\n"));
    });
  };

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 取得キーワード管理";

    fetchData();
  }, [state.user.account_id]);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, state.user.account_id)
  }, [props.location.pathname]);

  React.useEffect(() => {
    let count = 0;
    let keywordsCount = 0;
    let excludeKeywordsCount = 0;

    if (keywords !== "") {
      const splitRow = keywords.split("\n").filter((v) => v);
      count += splitRow.length;
      keywordsCount += splitRow.length;
      splitRow.map((row) => {
        count += row.replace(/,$/g, "").split(",").length - 1;
        keywordsCount += row.replace(/,$/g, "").split(",").length - 1;
      });
    }

    if (excludeKeywords !== "") {
      const splitRow = excludeKeywords.split("\n").filter((v) => v);
      count += splitRow.length;
      excludeKeywordsCount += splitRow.length;
      splitRow.map((row) => {
        count += row.replace(/,$/g, "").split(",").length - 1;
        excludeKeywordsCount += row.replace(/,$/g, "").split(",").length - 1;
      });
    }

    setKeywordsCount(keywordsCount);
    setExcludeKeywordsCount(excludeKeywordsCount);
    setCount(count);
  }, [keywords, excludeKeywords]);

  //  Update 2023.05.31 取得キーワードと除外キーワードの個数チェック
  React.useEffect(() => {
    if (maxWords < keywordsCount) {
      setIsErrorKeywords(true);
      setErrorMessageKeywords(messages.errorMsg.overGetKeywords);
    }
    else {
      setIsErrorKeywords(false);
      setErrorMessageKeywords("");
    }
    if (maxWords < excludeKeywordsCount) {
      setIsErrorExcludeKeywords(true);
      setErrorMessageExcludeKeywords(messages.errorMsg.overExcludeKeywords);
    }
    else {
      setIsErrorExcludeKeywords(false);
      setErrorMessageExcludeKeywords("");
    }
  }, [keywordsCount, excludeKeywordsCount, maxWords]);

  return (
    <Layout
      content={
        <div>
          <Grid item xs={12}>
            <Paper className={fixedHeightPaper}>
              <Chart
                data={filterHorse}
                dataKey="date"
                currentLimit={currentLimit}
              />
            </Paper>
          </Grid>
          <form
            className={classes.wrapper}
            onSubmit={(e) => {
              e.preventDefault();
              submit();
            }}
          >
            <Grid>
              <Paper elevation={3} className={classes.paper}>
                <Typography variant="h6" color="primary">
                  取得キーワード
                </Typography>
                <Typography variant="subtitle2" className={classes.subtitle}>
                  ※ここに設定したキーワードを含むツイートを取得します。
                  複数設定する場合は、改行区切りで入力してください。
                </Typography>
                <Typography variant="subtitle2" className={classes.subtitle}>
                  ※AND条件は、”,“（カンマ）区切りで横に並べて入力してください。
                  詳細はマニュアルをご確認ください。
                </Typography>
                <Grid item>
                  <TextField
                    label="取得キーワード"
                    multiline
                    minRows={10}
                    maxRows={10}
                    fullWidth
                    onChange={(event) => {
                      setKeywords(event.target.value);
                    }}
                    value={keywords}
                    disabled={!state.user.master && locked}
                  />
                </Grid>
              </Paper>
            </Grid>
            {/* Add 2023.05.31 */}
            {isErrorKeywords && (
              <Alert severity="error" className={classes.alert}>
                {errorMessageKeywords}
              </Alert>
            )}
            <Grid className={classes.wrapper} container justifyContent="flex-end">
              <Typography>取得キーワード数：</Typography>
              {/* Update 2023.05.31 */}
              <Typography><span className={(isErrorKeywords == false) ? classes.countDef : classes.countErr}>{keywordsCount}</span> / {maxWords}</Typography>
            </Grid>

            {/* TODO: スタータープラン廃止後は除外キーワード表示関連部分を削除する */}
            {starterPlan.includes(contractType) && (
            <Grid className={classes.wrapper}>
              <Paper elevation={3} className={classes.paper}>
                <Typography variant="h6" color="primary">
                  除外キーワード
                </Typography>
                <Typography variant="subtitle2" className={classes.subtitle}>
                  ※取得キーワードを含むツイートのうち、「除外キーワード」を含むものは取得されなくなります。
                </Typography>
                <Typography variant="subtitle2" className={classes.subtitle}>
                  ※複数設定する場合は、改行区切りで入力してください。
                  詳細はマニュアルをご確認ください。
                </Typography>
                <Grid item>
                  <TextField
                    label="除外キーワード"
                    multiline
                    minRows={5}
                    maxRows={5}
                    fullWidth
                    onChange={(event) => {
                      setExcludeKeywords(event.target.value);
                    }}
                    value={excludeKeywords}
                    disabled={!state.user.master && locked}
                  />
                </Grid>
              </Paper>
            </Grid>
            )}

            {/* TODO: スタータープラン廃止後は除外キーワード表示関連部分を削除する */}
            {/* Add 2023.05.31 */}
            {starterPlan.includes(contractType) && isErrorExcludeKeywords && (
              <Alert severity="error" className={classes.alert}>
                {errorMessageExcludeKeywords}
              </Alert>
            )}
            {/* TODO: スタータープラン廃止後は除外キーワード表示関連部分を削除する */}
            {starterPlan.includes(contractType) && (<>
            <Grid className={classes.wrapper} container justifyContent="flex-end">
              <Typography>除外キーワード数：</Typography>
              {/* Update 2023.05.31 */}
              <Typography><span className={(isErrorExcludeKeywords == false) ? classes.countDef : classes.countErr}>{excludeKeywordsCount}</span> / {maxWords}</Typography>
            </Grid>

            {/* Update 2023.05.31 */}
            <Grid className={classes.wrapper} container justifyContent="flex-end">
              <Typography>合計キーワード数：</Typography>
              <Typography>{count} / {maxWords}</Typography>
            </Grid>
            </>)}

            <Grid className={classes.wrapper} container justifyContent="flex-end">
              {state.user.master && (
                <FormControlLabel
                  className={classes.checkbox}
                  control={
                    <Checkbox
                      onChange={(event) => {setLock(event.target.checked)}}
                      color="primary"
                      checked={lock}
                    />
                  }
                  label="キーワードの編集をロックする"
                />
              )}
              {!state.user.master && locked && (
                <Typography>マスターユーザによりロックされています</Typography>
              )}
            </Grid>
            {isError && (
              <Alert severity="error" className={classes.alert}>
                {errorMessage}
              </Alert>
            )}
            {isSuccess && (
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                更新が完了しました
              </MuiAlert>
            )}

            <Grid container justifyContent="center" className={classes.wrapper}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={(!state.user.master && locked) || isErrorKeywords == true || isErrorExcludeKeywords == true}
              >
                登録
              </Button>
            </Grid>
          </form>
          {dialogConfig && <NoYesDialog {...dialogConfig} />}
        </div>
      }
    />
  );
}
